quoteModule.factory('vehicleProductsProcessingService',
    ['$window', 'vehicleProductCoordService', 'rateQuoteRetrievalCoordService', 'vehicleProductService', 'vehicleRateService',
        'rateQuoteCoordService', 'rateQuotePersistService','vehicleDefinitionService','settingsCacheService','providerFeaturesService',
        '$q', 'erateSessionVarsService', 'quoteIntegrationConstants', 'quoteIntegrationService', 'imSessionVarsService',
    function ($window, vehicleProductCoordService, rateQuoteRetrievalCoordService, vehicleProductService, vehicleRateService,
              rateQuoteCoordService, rateQuotePersistService, vehicleDefinitionService, settingsCacheService,providerFeaturesService,
              $q, erateSessionVarsService, quoteIntegrationConstants, quoteIntegrationService, imSessionVarsService) {
        var processingSvc = {};
        processingSvc.productData = {
            haveProducts : false,
            allProducts: [],
            showRates: {},
            rateSummaryData: {},
            filteringProducts: []
        };
        processingSvc.filteringProductsChanged = false;
        processingSvc.vehicleInfoDataChanged = false;
        processingSvc.forceLoadProducts = false;

        processingSvc.requestGuids = [];

        var handlers = {
            productError : {}
        };
        //doing .push multiple times creates multiple handler calls.. doing based on the
        // registered handler
        var productError = function(errorMsg) {
            processingSvc.productData.haveProducts = false;
            for (var prop in handlers.productError){
                if (handlers.productError.hasOwnProperty(prop)){
                    handlers.productError[prop](errorMsg);
                }
            }
        };
        processingSvc.onProductError = function(errorHandler, key) {
            if (!handlers.productError[key])
                handlers.productError[key] = errorHandler;
        };

        processingSvc.clearRateSummaryDataAndProducts = function(){
            processingSvc.productData.rateSummaryData = {};
            processingSvc.productData.showRates = {};
            processingSvc.clearProducts();
        }

        processingSvc.clearProducts = function(newSession) {
            processingSvc.productData.haveProducts = false;
            while(processingSvc.productData.allProducts.pop()){ /* empty the array */}

            vehicleRateService.deregisterAllHandlers();
            //when we are just starting with products, we can "start" a new quoting session
            if (newSession && !rateQuoteRetrievalCoordService.inQuoteRetrieval()) {
                rateQuoteCoordService.startNewQuoteSession();
                rateQuotePersistService.startNewQuote();
            }
        };

        // vehicle info data
        processingSvc.setVehicleInfoDataChanged = function(vehicleInfoChanged) {
            processingSvc.vehicleInfoDataChanged = vehicleInfoChanged;
        }

        processingSvc.getVehicleInfoDataChanged = function() {
            return processingSvc.vehicleInfoDataChanged;
        }

        // product filtering
        processingSvc.getFilteringProducts = function() {
            return processingSvc.productData.filteringProducts;
        }

        processingSvc.setFilteringProducts = function(filteringProds) {
            processingSvc.productData.filteringProducts = filteringProds;
        }

        processingSvc.getFilteringProductsChanged = function() {
            return processingSvc.filteringProductsChanged;
        }

        processingSvc.setFilteringProductsChanged = function(selectionChanged) {
            return processingSvc.filteringProductsChanged = selectionChanged;
        }

        processingSvc.setFilteringProductsSelection = function(selectionChanged, productCodes) {
            processingSvc.filteringProductsChanged = selectionChanged;
            processingSvc.productData.filteringProducts = productCodes;
        }

        processingSvc.getForceLoadProducts = function(){
            return processingSvc.forceLoadProducts;
        }

        processingSvc.setForceLoadProducts = function(forceIt) {
            processingSvc.forceLoadProducts = forceIt;
        }

        processingSvc.getAllFilteringProductsByProvider = function(//dos, vin, odometer,
            guid, dealerAccountCode, providerCode) {
            var deferred = $q.defer();
            var quoteMode = erateSessionVarsService.getQuotingMode();
            var menuMode = quoteIntegrationConstants.menuQuoteIntegrated;
            var vehicleInfo = quoteIntegrationService.getIntegratedVehicleData();
            var dos = quoteIntegrationService.getIntegratedVehicleData.dateOfSale;


            var productFilteringFlag = (imSessionVarsService.getCurrentProviderSettings('product-filtering') != 'false' && imSessionVarsService.getCurrentProviderSettings('product-filtering') != undefined  && imSessionVarsService.getCurrentProviderSettings('product-filtering') != null)  ? true : false;
            // Checking the feature flag
            if (quoteMode == menuMode && productFilteringFlag) {
                vehicleProductService.getAllProductsByProvider(dos, vehicleInfo.vin, vehicleInfo.odometer, guid, dealerAccountCode, providerCode).then(
                    function gotAllProductsByProvider(gotData) {
                        var filteringProducts = (gotData.status == 200) ? processingSvc.processAllProducts(gotData.data.Products, quoteIntegrationService.getProductsToQuote()) : null;
                        var prodCodes = filteringProducts ? processingSvc.getFilteredProductCodes(filteringProducts) : null;
                        processingSvc.setFilteringProducts(prodCodes);
                        deferred.resolve({data: filteringProducts, showPT: (gotData.status == 200)});
                    }
                )
            }
            else {
                processingSvc.allFilteringProducts = null;
                processingSvc.setFilteringProducts(null);
                deferred.resolve({data: [], showPT: false});
            }
            return deferred.promise;
            // Checking the feature flag
        };

        processingSvc.getFilteredProductCodes = function(productsFromWeb){
            var filteredProds = _.filter(productsFromWeb, function (item) {
                return item && item.checked;
            });
            return (filteredProds && filteredProds.length > 0) ? filteredProds.map(function(item) { return item.productCode }) : [];
        }

        processingSvc.processAllProducts = function(inProducts, prodsToQuote) {
            var filteringProducts = [];
            var allProducts = productsSort(inProducts);
            allProducts.forEach(function(item){
                var prod = {
                    productCode: item.InternalProductId,
                    productName: item.DisplayName,
                    partnerCode: null,
                    commerceRateType: null,
                    disabled: true,
                    checked: false
                };
                if (item.ParentProductType != null) {
                    prod.partnerCode = item.ParentProductType.PartnerCode.toUpperCase();
                    if (item.ParentProductType.ParentProductRatingCategory != null && item.ParentProductType.ParentProductRatingCategory.PartnerSpecificFields != null
                        && item.ParentProductType.ParentProductRatingCategory.PartnerSpecificFields.FlexFields != null) {
                        //var rateType = item.ParentProductType.ParentProductRatingCategory.PartnerSpecificFields.FlexFields.find(a => a.FieldName == "COMMERCE-RATE-TYPE");
                        var rateType = _.find(item.ParentProductType.ParentProductRatingCategory.PartnerSpecificFields.FlexFields, function(flexField) {
                            return flexField.FieldName === 'COMMERCE-RATE-TYPE';
                        });
                        if (rateType != null) prod.commerceRateType = rateType.FieldValue.toUpperCase();
                    }
                }
                if (prodsToQuote != null) {
                    //var selected = prodsToQuote.find(a => (a != null && (a.productTypeCode == prod.partnerCode || (prod.commerceRateType != null && prod.commerceRateType == a.productTypeCode))))
                    var selected = _.find(prodsToQuote, function(prodToQuote) {
                        return prodToQuote != null && (prodToQuote.productTypeCode == prod.partnerCode || (prod.commerceRateType != null && prod.commerceRateType == prodToQuote.productTypeCode));
                    });
                    if (selected) {
                        prod.disabled = false;
                        prod.checked = true;
                    }
                }
                if (!prod.disabled) filteringProducts.push(prod);       // not show those disabled (not from menu)
            });
            //processingSvc.allFilteringProducts = filteringProducts;
            return filteringProducts;
        };


        processingSvc.GetEligibleProducts = function(){
            //I HATE this b/c we are putting RV-specific logic here. If we get anymore
            // specific stuff, we need to pull this out to a service
            // wbh 1-10-2017
            var forceIt = processingSvc.getForceLoadProducts();
            var purchasePriceOK = (!rateQuoteCoordService.VehicleData.vehicleType || rateQuoteCoordService.VehicleData.vehicleType == 'AUTO') ? true : parseFloat(rateQuoteCoordService.DealData.sellingPrice) >= 1000.0;
            //PD-351 - We are saving the number of requests for products we are doing
            var guid = rateQuoteCoordService.getQuoteSessionId();
            processingSvc.requestGuids.push(guid);
            if (purchasePriceOK && rateQuoteCoordService.VehicleData && rateQuoteCoordService.VehicleData.dataReadyToSaveQuote()) {
                vehicleProductCoordService.collectVehicleDetails(rateQuoteCoordService.VehicleData);
                //are we in retrieving an existing quote??
                if (rateQuoteRetrievalCoordService.inQuoteRetrieval() && (!forceIt)) {
                    rateQuoteRetrievalCoordService.getSavedQuoteProducts()
                        .then(
                            function savedQuoteFound(foundProducts) {
                                processingSvc.requestGuids.shift();
                                angular.extend(processingSvc.productData, processProductData(foundProducts));
                            }, function noSavedQuote(err) {
                                getNewVehicleProducts(rateQuoteCoordService.VehicleData, rateQuoteCoordService.DealData);
                            }
                        );
                }
                else {
                    getNewVehicleProducts(rateQuoteCoordService.VehicleData, rateQuoteCoordService.DealData);
                }
            }else{
                processingSvc.requestGuids.shift();
                vehicleDefinitionService.vehicleDetailsData.ready = false;
            }
        };

        function getNewVehicleProducts(vehicleData, dealData){
            providerFeaturesService.getProviderApplicationSetting("AllowDefaultProposal",'false')
            .then(
                function(element){
                    //detemine if provider does "default products"
                    var provAllowDefaultProposal = element.toString().toUpperCase() === "TRUE";

                    //get products by either vin or model
                    var getProductsFunc = vehicleData.vin ? vehicleProductService.getProductsForVehicleByVIN : vehicleProductService.getProductsForVehicleByModel;

                    var guid = rateQuoteCoordService.getQuoteSessionId();
                    var rvInfo = null;
                    var cust = rateQuoteCoordService.CustomerData;
                    if (vehicleData.vehicleType!=null && vehicleData.vehicleType == 'RV'){
                        rvInfo = {
                            rvType : vehicleData.rvType,
                            manuWarrMonths : vehicleData.rvManuMonths,
                            manuWarrMiles : vehicleData.rvManuMiles,
                            modelYear : vehicleData.year
                        }
                    }

                    var prefProductCodes = null;
                    var filteredCodes = null;
                    if (vehicleData.defaultProductsOnly === 'true' && provAllowDefaultProposal){
                        prefProductCodes = settingsCacheService.getCachedDefaultProductCodes(vehicleData.dateOfSale);
                        filteredCodes = prefProductCodes ?  _.filter(prefProductCodes, function(code) { return code && code.length > 0 && code.toUpperCase() != '*DEFAULT*'}) : null;
                        if (!(filteredCodes && filteredCodes.length > 0))
                            filteredCodes = null;
                        if (!(filteredCodes && filteredCodes.length > 0)){
                            processingSvc.requestGuids.shift();
                            processingSvc.clearProducts(true);
                            productError("Please set up default products.");
                            processingSvc.productData.haveProducts = true;//just to end the spinner
                            return;
                        }
                    }

                    // further filtering the product based on selection from the product filtering tab...
                    if (processingSvc.productData.filteringProducts && processingSvc.productData.filteringProducts.length > 0) {
                        if (filteredCodes && filteredCodes.length > 0) {
                            filteredCodes = _.filter(filteredCodes, function(code) { return code && processingSvc.productData.filteringProducts.includes(code); });
                        }
                        else {
                            filteredCodes = processingSvc.productData.filteringProducts;
                        }
                    }

                    if (vehicleData.vehicleUsage && !Array.isArray(vehicleData.vehicleUsage))
                    {
                        vehicleData.vehicleUsage = [vehicleData.vehicleUsage];
                    }
                    getProductsFunc(
                        vehicleData.dateOfSale,
                        vehicleData.vin ? vehicleData.vin : vehicleData.modelId,
                        vehicleData.odometer,
                        vehicleData.vehicleCert,
                        vehicleData.vehicleUsage,
                        vehicleData.inService ? vehicleData.inService : null,
                        dealData,
                        cust,
                        rvInfo,
                        guid,
                        filteredCodes
                    )
                    .then(function gotProducts(data) {
                        processingSvc.requestGuids.shift();
                        angular.extend(processingSvc.productData, processProductData(data));
                    }, function errorRetrievingProducts(err) {
                        processingSvc.requestGuids.shift();
                        processingSvc.clearProducts(true);
                        productError("No products found for dealer and vehicle.");
                        processingSvc.productData.haveProducts = true;//just to end the spinner
                    });
                }
            );
        };

        // refactor it out for re-use ...
        function productsSort(products) {
            var menuData = quoteIntegrationService.getIntegrationData();
            var quotesFromMenu = null;
            if (menuData){
                quotesFromMenu = menuData.productsToQuote;
            }
            
            return products.sort(function sortProducts(a, b) {
                var aSort = getRatedProductFlexField(a,"SORTORDER");
                var bSort = getRatedProductFlexField(b,"SORTORDER");

                var aRateType = getRatedProductFlexField(a,"COMMERCE-RATE-TYPE"); 
                aRateType = aRateType ? aRateType.toUpperCase() : "NORATETYPE";
                var bRateType = getRatedProductFlexField(b,"COMMERCE-RATE-TYPE");
                bRateType = bRateType ? bRateType.toUpperCase() : "NORATETYPE";

                var aMenuLocation = -1;
                var bMenuLocation = -1;
                if (quotesFromMenu && quotesFromMenu.length > 0){ 
                    var i = 0
                    _.forEach(quotesFromMenu,function(itm)
                    {
                        if (itm && itm.productTypeCode && itm.productTypeCode.toUpperCase() == aRateType)
                            aMenuLocation = i;
                        i = i+1;
                    });
                    i=0;
                    _.forEach(quotesFromMenu,function(itm)
                    {
                        if (itm && itm.productTypeCode && itm.productTypeCode.toUpperCase() == bRateType)
                            bMenuLocation = i;
                        i = i+1;
                    });
                }

                if (aMenuLocation >= 0 || bMenuLocation >= 0){
                    aMenuLocation = aMenuLocation >= 0 ? aMenuLocation : 999;
                    bMenuLocation = bMenuLocation >= 0 ? bMenuLocation : 999;

                    return aMenuLocation > bMenuLocation ? 1 : (aMenuLocation < bMenuLocation ? -1 : (aSort > bSort ? 1 : (aSort < bSort ? -1 : 0)));
                }
                else if (!aSort){
                    if (!a.SortOrder)
                    a.SortOrder = a.ParentProductType ? a.ParentProductType.ParentProductRatingCategory.ApplicationCode : a.DisplayName;
                    if (!b.SortOrder)
                        b.SortOrder = b.ParentProductType ? b.ParentProductType.ParentProductRatingCategory.ApplicationCode : b.DisplayName;

                    if (a.SortOrder.toUpperCase() <
                        b.SortOrder.toUpperCase()) {
                        return -1;
                    }
                    if (a.SortOrder.toUpperCase() >
                        b.SortOrder.toUpperCase()) {
                        return 1;
                    }
                }else{
                    return aSort > bSort ? 1 : (aSort < bSort ? -1 : 0);
                }
            });
        }

        function processProductData(data) {
            var productInfo = {
                showRates : {}
            };
            data.Products = productsSort(data.Products);
            if (processingSvc.requestGuids.length == 0) {
                data.Products.forEach(function (val) {
                    if (!rateQuoteRetrievalCoordService.inQuoteRetrieval() || processingSvc.productData.showRates[val.InternalProductId] == undefined || (rateQuoteRetrievalCoordService.inQuoteRetrieval() && processingSvc.productData.showRates[val.InternalProductId] != undefined))
                        productInfo.showRates[val.InternalProductId] = true;

                    vehicleProductCoordService.collectSingleProductData(val, data.CachedResponseId);
                });
                productInfo.haveProducts = processingSvc.productData.haveProducts = true;
                productInfo.allProducts = processingSvc.productData.allProducts = data.Products;
            }
            return productInfo;
        }

        var getRatedProductFlexField = function(prod, fieldName) {
            var flexFields = prod
                && prod.PartnerSpecificFields
                && prod.PartnerSpecificFields.FlexFields;
    
            if (!angular.isArray(flexFields))
                return angular.undefined;
    
            var field = _.find(flexFields, function (fieldObj) { return fieldObj.FieldName == fieldName});
    
            return field && field.FieldValue;
        }

        return processingSvc;
    }
]);
